import { AxiosResponse } from 'axios'
import {
  IGenericEntityResponse,
  IGenericResponse
} from 'services/core/entityResponseCore'
import { RequestCDU, RequestGENERIC, RequestREAD } from 'services/Instances'
import { Setor } from 'utils/types'
export const SectorServices = () => {
  const path = 'Setor'
  const create = async (requestObj: Setor): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/Create`, requestObj)

  const del = async (id: number): Promise<AxiosResponse> =>
    await RequestCDU.delete(`${path}/Delete?id=${id}`)

  const get = async (id?: number): Promise<AxiosResponse> =>
    id ? await RequestREAD.get(`${path}/${id}`) : await RequestREAD.get(path)
  const patch = async (): Promise<AxiosResponse> =>
    await RequestCDU.patch(`${path}/Update`)

  return { create, del, get, patch }
}

export const notificationService = () => {
  const path = 'tipoPendencia'

  const getAll = async (): Promise<AxiosResponse> => await RequestREAD.get(path)

  const getPendencias = async (): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/PendenciasNGT`)

  return { getAll, getPendencias }
}

export const LogEmailJobService = () => {
  const path = 'LogEmailJob'
  const getTipos = async (): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/TiposJob`)

  const getWithFilters = async (resquestObj: any): Promise<AxiosResponse<IPaginatedEntityNGT<IGetWithFiltersResponse[]>>> =>
    await RequestREAD.get(`${path}/GetWithFilters`, {
      params: resquestObj
    })

  return { getTipos, getWithFilters }
}

export const JobsService = () => {
  const path = 'Job'

  const alterarEmailCorpo = async (idHangfireJob: string, requestObj: any) =>
    RequestCDU.patch(
      `${path}/AlterarEmailCorpo?IdHangfireJob=${idHangfireJob}`,
      requestObj
    )

  const alterarEmails = async (idHangfireJob: string, requestObj: any) =>
    RequestCDU.patch(
      `${path}/AlterarEmails?IdHangfireJob=${idHangfireJob}`,
      requestObj
    )

  const alterarDataPlanejamento = async (
    request: IJobAlterarDataPlanejamento
  ) =>
    RequestCDU.patch(
      `${path}/AlterarDataPlanejamento?idHangfireJob=${request.idHangfireJob}`,
      request
    )

  const alterarRecorrencia = async (idHangfireJob: string, requestObj: any) =>
    RequestCDU.patch(
      `${path}/AlterarRecorrencia?IdHangfireJob=${idHangfireJob}`,
      requestObj
    )

  const getAll = async (): Promise<AxiosResponse<GetAllJobsResponse[]>> =>
    await RequestREAD.get(path)

  const suspender = async (idHangfireJob: string, flAtivo: boolean) =>
    await RequestCDU.patch(
      `${path}/AlterarEstado?IdHangfireJob=${idHangfireJob}&FlAtivo=${flAtivo}`
    )

  const deleteJob = async (idHangfireJob: string) =>
    await RequestCDU.delete(`${path}/Excluir?IdHangfireJob=${idHangfireJob}`)

  return {
    alterarDataPlanejamento,
    alterarEmailCorpo,
    alterarEmails,
    alterarRecorrencia,
    deleteJob,
    getAll,
    suspender
  }
}

export interface IGetWithFiltersResponse {
  cdMatriculaContraparte: string
  dtEnvioEmail: string
  idLogEmailJob: 1
  nmContraparte: string
  nmFornecedor: string
  nmTipoJOB: string
  txEmailResponsavel: string
}
export interface JobInfo {
  idJobInfo: number
  txTipoRecorrencia: string
  dtPlanejamentoInicio: Date
  dtPlanejamentoFim: Date
  nuHoraRecorrencia: string
  nuMinutoRecorrencia: string
  txDiasSemanaRecorrencia: string
  nuDiasRecorrencia: string
  idJob: number
}

export interface JobAlterarRecorrencia {
  tipoRecorrencia: string
  txDiasSemanaRecorrencia?: string
  nuDiasRecorrencia?: string
  listaHoras?: ListaHoras[]
}

export interface ListaHoras {
  idJobRecorrencia?: number
  horaRecorrencia: string
}

export interface JobEmail {
  idJobEmail: number
  txEmailDestinatario: string
  nmDestinatario: string
  idJob: number
}

export interface IJobAlterarDataPlanejamento {
  dtInicioPlanejamento: Date
  dtFimPlanejamento: Date
  idHangfireJob: string
}

export interface JobRecorrencia {
  idJobRecorrencia: number
  hrRecorrencia: string
  idJob: number
}

export interface GetAllJobsResponse {
  idJob: number
  idHangfireJob: string
  nmJob: string
  jobInfo: JobInfo
  jobEmails: JobEmail[]
  jobRecorrencias: JobRecorrencia[]
  flAtivo: boolean
  flExcluido: boolean
}

export const EmailGroup = () => {
  const path = 'GrupoEmail'

  const getAll = async (): Promise<AxiosResponse> => await RequestREAD.get(path)

  const create = async (requestObj: GrupoEmail) =>
    await RequestCDU.post(`${path}/create`, requestObj)

  const update = async (requestObj: GrupoEmail) =>
    await RequestCDU.patch(`${path}/Update`, requestObj)

  const DeleteGrupoEmail = async (requestObj: number) =>
    await RequestCDU.delete(`${path}/Delete/?id=${requestObj}`)

  return { DeleteGrupoEmail, create, getAll, update }
}

export const managementUnitService = () => {
  const path = 'UnidadeGestora'

  const getAll = async (): Promise<AxiosResponse> => await RequestREAD.get(path)
  const AutoComplete = async (
    tpUnidade: string,
    name: string
  ): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/AutoComplete/${tpUnidade}/${name}`)
  return { AutoComplete, getAll }
}

export const creService = () => {
  const path = 'TipoCre'

  const getAll = async (): Promise<AxiosResponse> => await RequestREAD.get(path)

  return { getAll }
}

export const TalkWithUsServices = () => {
  const path = 'ParamFaleConosco'

  const getParamFaleConosco = async (): Promise<AxiosResponse> =>
    await RequestREAD.get(path)

  const createParamFaleConosco = async (requestObj: any) =>
    await RequestCDU.post(path, requestObj)

  const getAllAutocomplete = async (): Promise<
    AxiosResponse<ParamFaleConoscoResponseDto[]>
  > => await RequestREAD.get(`${path}/GetAutoComplete`)

  const getById = async (
    id: number
  ): Promise<AxiosResponse<ParamFaleConoscoResponseDto>> =>
    await RequestREAD.get(`${path}/GetParamFaleConosco/${id}`)

  const deleteParamFaleConosco = async (id: number) =>
    await RequestCDU.delete(`${path}/Delete/${id}`)

  const editParamFaleConosco = async (requestObj: any) =>
    await RequestCDU.put(path, requestObj)

  return {
    createParamFaleConosco,
    deleteParamFaleConosco,
    editParamFaleConosco,
    getAllAutocomplete,
    getById,
    getParamFaleConosco
  }
}

export const RolDocumentsServices = () => {
  const path = 'RolDocumento'

  const getRolDocumento = async (
    id: number
  ): Promise<AxiosResponse<ResponseRolDocumento>> =>
    await RequestREAD.get(path + '/' + id)

  const getAllRolDocumento = async (): Promise<
    AxiosResponse<IGenericEntityResponse<RolDocumentoModel[]>>
  > => {
    return await RequestREAD.get(path)
  }

  const getAllRolDocumentoWithParametrization = async (): Promise<
    AxiosResponse<IGenericEntityResponse<RolDocumentoModel[]>>
  > => {
    return await RequestREAD.get(`${path}/ComParametrizacao`)
  }

  const getFiltroRolDocumento = async (
    requestFiltro?: RequestFiltro
  ): Promise<AxiosResponse> =>
    await RequestREAD.get(path + '/Filtro', {
      params: requestFiltro
    })

  const getParametrosCDU = async (
    id: number
  ): Promise<AxiosResponse<ResponseParamsCDU>> =>
    await RequestREAD.get(path + `/ParametrosCdu/${id}`, {})

  const getAllParametrosCDU = async (): Promise<
    AxiosResponse<ResponseAllRolDocumento>
  > => await RequestREAD.get(path + '/ParametrosCdu')
  const getParametrosFiltros = async (): Promise<
    AxiosResponse<ResponseAllRolDocumento>
  > => await RequestREAD.get(path + '/ParametrosFiltros')

  const createRolDocs = async (
    requestObj: RequestRolDocs
  ): Promise<AxiosResponse> => RequestCDU.post(path + '/Create', requestObj)

  const deleteRolDocs = async (id: number): Promise<AxiosResponse> =>
    RequestCDU.delete(path + '/Delete', {
      params: {
        id: id
      }
    })

  const updateRolDocs = async (
    requestObj: RequestRolDocs
  ): Promise<AxiosResponse> => RequestCDU.patch(path + '/Update', requestObj)
  return {
    createRolDocs,
    deleteRolDocs,
    getAllParametrosCDU,
    getAllRolDocumento,
    getAllRolDocumentoWithParametrization,
    getFiltroRolDocumento,
    getParametrosCDU,
    getParametrosFiltros,
    getRolDocumento,
    updateRolDocs
  }
}

export const ConsolidationServices = () => {
  // EXECUTIVOS
  const getAllExecutives = async () =>
    await RequestREAD.get('DiretoriaConsolidacao')
  const createExecutive = async (requestObj: any) =>
    await RequestCDU.post('DiretoriaConsolidacao/Create', requestObj)
  const updateExecutive = async (requestObj: any) =>
    await RequestCDU.patch('DiretoriaConsolidacao/Update', requestObj)
  const deleteExecutive = async (id: number) =>
    await RequestCDU.delete('DiretoriaConsolidacao/Delete', {
      params: {
        id: id
      }
    })
  // EMPRESAS
  const getAllCompanies = async () =>
    await RequestREAD.get('EmpresaConsolidacao')
  const createCompanies = async (requestObj: any) =>
    await RequestCDU.post('EmpresaConsolidacao/Create', requestObj)
  const updateCompanies = async (requestObj: any) =>
    await RequestCDU.patch('EmpresaConsolidacao/Update', requestObj)
  const deleteCompanies = async (id: number) =>
    await RequestCDU.delete('EmpresaConsolidacao/Delete', {
      params: {
        id: id
      }
    })
  // UNIDADE
  const getAllBusinessUnit = async () =>
    await RequestREAD.get('UnidadeNegocioConsolidacao')
  const createBusinessUnit = async (requestObj: any) =>
    await RequestCDU.post('UnidadeNegocioConsolidacao/Create', requestObj)
  const updateBusinessUnit = async (requestObj: any) =>
    await RequestCDU.patch('UnidadeNegocioConsolidacao/Update', requestObj)
  const deleteBusinessUnit = async (id: number) =>
    await RequestCDU.delete('UnidadeNegocioConsolidacao/Delete', {
      params: {
        id: id
      }
    })
  // AREA
  const getAlltAreaConsolidation = async () =>
    await RequestREAD.get('AreaConsolidacao')
  const createAreaConsolidation = async (requestObj: any) =>
    await RequestCDU.post('AreaConsolidacao/Create', requestObj)
  const updateAreaConsolidation = async (requestObj: any) =>
    await RequestCDU.patch('AreaConsolidacao/Update', requestObj)
  const deleteAreaConsolidation = async (id: number) =>
    await RequestCDU.delete('AreaConsolidacao/Delete', {
      params: {
        id: id
      }
    })

  const saveConsolidation = async (
    data: ISaveConsolidation
  ): Promise<AxiosResponse<IGenericResponse>> =>
    await RequestCDU.post('Consolidacao/CreateOrUpdate', data)

  // ROTAS AGREGADAS
  const aggregatedEfetivos = async (): Promise<
    AxiosResponse<IAggregatedConsolidacaoEfetivo>
  > => await RequestGENERIC.get('aggregatedEfetivos_consolidacaoEfetivo')

  const aggregatedParametrizacaoConsolidacao = async (): Promise<
    AxiosResponse<IAggregatedParamsConsolidacao>
  > => await RequestGENERIC.get('aggregatedParametrizacao_consolidacao')

  return {
    aggregatedEfetivos,
    aggregatedParametrizacaoConsolidacao,
    createAreaConsolidation,
    createBusinessUnit,
    createCompanies,
    createExecutive,
    deleteAreaConsolidation,
    deleteBusinessUnit,
    deleteCompanies,
    deleteExecutive,
    getAllBusinessUnit,
    getAllCompanies,
    getAllExecutives,
    getAlltAreaConsolidation,
    saveConsolidation,
    updateAreaConsolidation,
    updateBusinessUnit,
    updateCompanies,
    updateExecutive
  }
}

export const ParamCockpitServices = () => {
  const path = 'ParametrizacaoCockpit'

  const getCentroPlantas = async (): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/GetCentroPlantasCockpit`)

  const createCentroPlantas = async (requestObj: any) =>
    await RequestCDU.post('CockpitCentroPlanta/Create', requestObj)

  const deleteCentroPlantas = async (id: number) =>
    await RequestCDU.delete('CockpitCentroPlanta/Delete', {
      params: { id: id }
    })

  const getMatriculas = async (): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/GetMatriculasCockpit`)

  const createMatriculas = async (requestObj: any) =>
    await RequestCDU.post('CockpitMatricula/Create', requestObj)

  const deleteMatriculas = async (id: number) =>
    await RequestCDU.delete('CockpitMatricula/Delete', {
      params: { id: id }
    })

  const getUnidadesGestoras = async (): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/GetUnidadesGestorasCockpit`)

  const createUnidadeGestora = async (requestObj: any) =>
    await RequestCDU.post('CockpitUnidadeGestora/Create', requestObj)

  const deleteUnidadeGestora = async (id: number) =>
    await RequestCDU.delete('CockpitUnidadeGestora/Delete', {
      params: { id: id }
    })

  return {
    createCentroPlantas,
    createMatriculas,
    createUnidadeGestora,
    deleteCentroPlantas,
    deleteMatriculas,
    deleteUnidadeGestora,
    getCentroPlantas,
    getMatriculas,
    getUnidadesGestoras
  }
}

export interface IConsolidation {
  idConsolidacao: number
  nuAnoMesCompetencia: number
  unidadeGestoraId: number
  diretoriaExecutivaId: number
  empresaId: number
  areaId: number
  unidadeNegocioId: number
  flConsolidado: boolean
}

export interface ISaveConsolidation {
  consolidacoes: IConsolidation[]
}

export interface IAggregatedParamsConsolidacao {
  parametrizacao_areaConsolidacao: IAreaResponse[]
  parametrizacao_diretoriaConsolidacao: IDiretoriaResponse[]
  parametrizacao_empresaConsolidacao: IEmpresaResponse[]
  parametrizacao_unidadeNegocioConsolidacao: IUnidadeNegocioResponse[]
}

export interface IAggregatedConsolidacaoEfetivo {
  efetivos_areaConsolidacao: IAreaResponse[]
  efetivos_diretoriaConsolidacao: IDiretoriaResponse[]
  efetivos_empresaConsolidacao: IEmpresaResponse[]
  efetivos_unidadeNegocioConsolidacao: IUnidadeNegocioResponse[]
}

export interface IAreaResponse {
  idAreaConsolidacao: number
  dsAreaConsolidacao: string
}

export interface IDiretoriaResponse {
  idDiretoriaConsolidacao: number
  dsDiretoriaConsolidacao: string
}

export interface IEmpresaResponse {
  idEmpresaConsolidacao: number
  dsEmpresaConsolidacao: string
}

export interface IUnidadeNegocioResponse {
  idUnidadeNegocioConsolidacao: number
  dsUnidadeNegocioConsolidacao: string
}

export interface ResponseConsolidationServicesCreate {
  valor: any
  sucesso: boolean
  mensagem: string
  detalhe: string
  tipo: string
}

export interface ResponseParamsCDU {
  entity: any[]
  sucesso: boolean
  mensagem?: any
  detalhe?: any
  tipo?: any
}

export interface ParamFaleConoscoResponseDto {
  idParamFaleConosco: number
  dsMotivo: string
}

type Nullable<TUnionType> = TUnionType | null | undefined

export interface RolDocumentoModel {
  idRolDocumento: number
  txtTipoDocumento: string
  txtDescDocumento: string
  cdTipoEfetivo: string
  cdStatusEfetivo: string
  cdCalcRisco: string
  cdPeriodicidade: string
  nuItem: number
  nuIndice: Nullable<number>
  rolPrincipalId: Nullable<number>
  tAmrRolPendencia: any[]
}

export interface RequestRolDocs {
  idRolDocumento?: number
  txtTipoDocumento: string
  txtDescDocumento: string
  cdTipoEfetivo: string
  cdStatusEfetivo: string
  cdCalcRisco: string
  cdPeriodicidade: string
  nuIndice: number
  rolPrincipalId: number
  tipoPendenciaId: number
}

export interface ResponseAllRolDocumento {
  entity: any[]
  sucesso: boolean
  mensagem?: any
  detalhe?: any
  tipo?: any
}

export interface RolDocumento {
  idRolDocumento?: number
  txtTipoDocumento?: string
  txtDescDocumento?: string
  descPendencia?: string
  tipoPendencia?: string
  cdTipoEfetivo?: string
  cdStatusEfetivo?: string
  cdCalcRisco?: string
  cdPeriodicidade?: string
  nuItem?: number
  nuIndice?: number
  rolPrincipalId?: any
  rolPrincipalNuItemDependente?: any
  tipoPendenciaId?: number
}

export interface ResponseRolDocumento {
  entity: any
  sucesso: boolean
  mensagem?: any
  detalhe?: any
  tipo?: any
}

export interface IParametrosRolDocumentos {
  chave: string
  valores: any[]
}

export interface RequestFiltro {
  nuItem?: string
  txtTipoDocumento?: string
  descPendencia?: string
  tipoPendencia?: string
  cdTipoEfetivo?: string
  cdStatusEfetivo?: string
}

export interface ILogEmailFilter {
  nmFornecedor: string
  TxEmailResponsavel: string
  DtEnvioInicio: string
  DtEnvioFim: string
  CdMatriculaContraparte: string
  NmContraparte: string
  NmTipoJOB: string
  PageNumber: number
  PageSize: number
}

export interface GrupoEmail {
  grupoEmailId?: number
  descricao?: string
  nome?: string
  ativo?: boolean
  grupoDeEmailItem?: any
}

export interface Suspender {
  jobId?: number
  ativo?: boolean
}

// Generic Generic NGT, equal GST
export enum IResponseTypes {
  success = 0,
  alert = 1,
  error = 2
}

export interface IPaginatedEntityNGT<T> extends IGenericResponseNGT {
  entity: {
    items: T
    pageCount: number
    totalItemCount: number
    pageNumber: number
    pageSize: number
    hasPreviousPage: boolean
    hasNextPage: boolean
    isFirstPage: boolean
    firstItemOnPage: number
    lastItemOnPage: number
  }
}

export interface IEntityNGT<T> extends IGenericResponseNGT {
  entity: T
}

export interface IGenericResponseNGT {
  mensagem: string
  detalhe: string
  tipo: IResponseTypes
}

